module.exports = __webpack_public_path__ + "static/card-img-1-4eb3847fafce2c8c0055cf999a201067.jpg";